<template>
  <section>
    <b-modal id="bv-modal-tecnicas" size="xl" title="Solicitações (CO e CE)" scrollable centered no-enforce-focus>
      <div class="modal-log">
        <fieldset class="made-up" v-if="this.getlogchat.nome || this.getlogchat.texto">
          <legend>Solicitações (CO e CE)</legend>
          <div class="row">
            <div class="col-md-12" v-if="this.getlogchat.nome">
              <label for="nome"><strong>Nome</strong></label>
              <input class="form-control" v-model="this.getlogchat.nome" type="text" id="nome" name="nome" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.texto">
              <label for="texto"><strong>Texto</strong></label>
              <div v-html="getlogchat.texto" class="fixed-height-input"></div>
            </div>
          </div>
        </fieldset>

        <fieldset class="made-up"
          v-if="this.getlogchat.contato || this.getlogchat.protocolo || this.getlogchat.assunto || this.getlogchat.created_at || this.getlogchat.created_by || this.getlogchat.motivo || this.getlogchat.sector">
          <legend>Dados do Atendimento</legend>
          <div class="row">

            <div class="col-md-12 espcForm" v-if="this.getlogchat.protocolo">
              <label for="protocolo"><strong>Protocolo</strong></label>
              <input class="form-control" v-model="this.getlogchat.protocolo" type="text" id="protocolo"
                name="protocolo" disabled>
            </div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.date">
              <label for="date"><strong>Data do Atendimento</strong></label>
              <input class="form-control" v-model="this.getlogchat.date" type="text" id="date" name="date" disabled>
            </div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.sla">
              <label for="sla"><strong>Prazo</strong></label>
              <input class="form-control" v-model="this.getlogchat.sla" type="text" id="sla" name="sla" disabled>
            </div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.numberId">
              <label for="numberId"><strong>Número do ID</strong></label>
              <input class="form-control" v-model="this.getlogchat.numberId" type="text" id="numberId" name="numberId"
                disabled>
            </div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.routeNumber">
              <label for="routeNumber"><strong>Número da Rota</strong></label>
              <input class="form-control" v-model="this.getlogchat.routeNumber" type="text" id="routeNumber" name="routeNumber"
                disabled>
            </div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.atmNumber">
              <label for="atmNumber"><strong>Número do ATM</strong></label>
              <input class="form-control" v-model="this.getlogchat.atmNumber" type="text" id="atmNumber" name="atmNumber"
                disabled>
            </div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.sector">
              <label for="sector"><strong>Área Responsável</strong></label>
              <input class="form-control" v-model="this.getlogchat.sector" type="text" id="sector" name="sector"
                disabled>
            </div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.approval">
              <label for="approval"><strong>Aprovação</strong></label>
              <input class="form-control" v-model="this.getlogchat.approval" type="text" id="approval" name="approval"
                disabled>
            </div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.motivo">
              <label for="motivo"><strong>Motivo de Acionamento</strong></label>
              <input class="form-control" v-model="this.getlogchat.motivo" type="text" id="motivo" name="motivo"
                disabled>
            </div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.assunto">
              <label for="assunto"><strong>Assunto</strong></label>
              <input class="form-control" v-model="this.getlogchat.assunto" type="text" id="assunto" name="assunto"
                disabled>
            </div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.created_at">
              <label for="created_at"><strong>Data de Criação</strong></label>
              <input class="form-control" v-model="this.getlogchat.created_at" type="text" id="created_at"
                name="created_at" disabled>
            </div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.created_by">
              <label for="created_by"><strong>Criado por</strong></label>
              <input class="form-control" v-model="this.getlogchat.created_by" type="text" id="created_by"
                name="created_by" disabled>
            </div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.updated_at">
              <label for="updated_at"><strong>Data de Alteração</strong></label>
              <input class="form-control" v-model="this.getlogchat.updated_at" type="text" id="updated_at"
                name="updated_at" disabled>
            </div>

            <div class="col-md-12 espcForm" v-if="this.getlogchat.updated_by">
              <label for="updated_by"><strong>Alterado por</strong></label>
              <input class="form-control" v-model="this.getlogchat.updated_by" type="text" id="updated_by"
                name="updated_by" disabled>
            </div>
          </div>
        </fieldset>

        <fieldset class="made-up"
          v-if="this.getlogchat.NomeCliente || this.getlogchat.cnpj || this.getlogchat.nomePonto || this.getlogchat.codigoPonto || this.getlogchat.endereco || this.getlogchat.cep">
          <legend>Dados da Base</legend>
          <div class="row">
            <div class="col-md-12" v-if="this.getlogchat.NomeCliente">
              <label for="NomeCliente"><strong>Cliente</strong></label>
              <input class="form-control" v-model="this.getlogchat.NomeCliente" type="text" id="NomeCliente"
                name="NomeCliente" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.cnpj">
              <label for="cnpj"><strong>CNPJ</strong></label>
              <input class="form-control" v-model="this.getlogchat.cnpj" type="text" id="cnpj" name="cnpj" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.nomePonto">
              <label for="nomePonto"><strong>Nome do Ponto</strong></label>
              <input class="form-control" v-model="this.getlogchat.nomePonto" type="text" id="nomePonto"
                name="nomePonto" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.codigoPonto">
              <label for="codigoPonto"><strong>Código Único do Ponto</strong></label>
              <input class="form-control" v-model="this.getlogchat.codigoPonto" type="text" id="codigoPonto"
                name="codigoPonto" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.Base">
              <label for="base"><strong>Base</strong></label>
              <input class="form-control" v-model="this.getlogchat.Base" type="text" id="base" name="base" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.endereco">
              <label for="endereco"><strong>Endereço</strong></label>
              <input class="form-control" v-model="this.getlogchat.endereco" type="text" id="endereco" name="endereco"
                disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.cep">
              <label for="cep"><strong>CEP</strong></label>
              <input class="form-control" v-model="this.getlogchat.cep" type="text" id="cep" name="cep" disabled>
            </div>
          </div>
        </fieldset>

        <fieldset class="made-up avoid-page-break"
          v-if="this.getlogchat && this.getlogchat.feedback && Object.keys(this.getlogchat.feedback).length">
          <legend>Feedback</legend>
          <div class="row">
            <div class="col-md-12" v-if="this.getlogchat.feedback.updated_by">
              <label for="userName"><strong>Enviado por</strong></label>
              <input class="form-control" v-model="this.getlogchat.feedback.updated_by" type="text" id="userName"
                name="userName" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.feedback.updated_at">
              <label for="nomePonto"><strong>Data de envio</strong></label>
              <input class="form-control" v-model="this.getlogchat.feedback.updated_at" type="text" id="nomePonto"
                name="nomePonto" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.feedback.message">
              <label for="codigoPonto"><strong>Mensagem</strong></label>
              <div class="form-control html-input" style="height: auto" v-html="this.getlogchat.feedback.message"
                type="text" disabled></div>
            </div>
          </div>
        </fieldset>

        <fieldset class="made-up avoid-page-break"
          v-if="this.getlogchat && this.getlogchat.notes && this.getlogchat.notes.length">
          <legend>Anotações</legend>
          <div class="notes-container">
            <div v-for="(note, index) in getlogchat.notes" :key="index" class="note-item">
              <span>{{ note.created_by }} - {{ moment(note.created_at).format('DD/MM/YYYY \à\\s HH:mm:ss') }}</span>
              <div class="form-control html-input" v-html="note.note.replace(/\n/g, '<br>')" type="text" disabled></div>
            </div>
          </div>
        </fieldset>

        <fieldset class="made-up avoid-page-break"
          v-if="this.getlogchat && this.getlogchat.attachments && this.getlogchat.attachments.length">
          <legend>Anexos</legend>
          <div class="attachments-container">
            <div class="composer-attachments"
              v-if="this.getlogchat.attachments && this.getlogchat.attachments?.length > 0">
              <ul>
                <li v-for="(attachment, attachIndex) in this.getlogchat.attachments" :key="attachIndex">
                  <span>
                    <i :class="getFileIcon(attachment.filename)"></i>
                    <span>{{ textSizeLimit(attachment.filename, 22) }}</span>
                    <small class="attachment-size">({{ formatFileSize(attachment.size) }})</small>
                  </span>
                  <a :href="attachment.download_url" :download="attachment.filename" class="download-attachment-btn"
                    title="Download anexo">
                    <i class="fas fa-download"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </fieldset>

        <fieldset class="made-up avoid-page-break"
          v-if="this.getlogchat && this.getlogchat.survey && Object.keys(this.getlogchat.survey).length">
          <legend>Pesquisa de Satisfação</legend>
          <div class="row">
            <div class="col-md-12" v-if="this.getlogchat.survey.avaliacao">
              <label for="userName"><strong>Avaliação</strong></label>
              <input class="form-control" v-model="this.getlogchat.survey.avaliacao" type="text" id="userName"
                name="userName" disabled>
            </div>
            <div class="col-md-12 espcForm" v-if="this.getlogchat.survey.reason">
              <label for="nomePonto"><strong>Razão da insatisfação</strong></label>
              <input class="form-control" v-model="this.getlogchat.survey.reason" type="text" id="nomePonto"
                name="nomePonto" disabled>
            </div>
          </div>
        </fieldset>
        
        <fieldset class="made-up avoid-page-break">
          <legend>Adicionar anexos</legend>
          <div id="attach-wrapper">
            <div class="checkbox-group" @click="addAttach()">
              <span><i class="fas fa-paperclip"></i> Anexar Arquivos</span>
            </div>
            <div class="composer-attachments" v-if="attachments.length > 0">
              <h5>Anexos:</h5>
              <ul>
                <li v-for="(file, index) in attachments" :key="index">
                  <span>
                    <i :class="getFileIcon(file.name)"></i>
                    <span>{{ textSizeLimit(file.name, 22) }}</span>
                  </span>
                  <button @click="removeAttach(index)" class="remove-attachment-btn" title="Remover anexo">✕</button>
                </li>
              </ul>
            </div>
          </div>
        </fieldset>
      </div>

      <template #modal-footer>
        <div class="buttons-container">
          <div class="change-sector-container">
            <span>Área responsável: </span>
            <select v-model="sector" class="form-control">
              <option value="select" disabled>Selecione uma área responsável</option>
              <option value="">Não atribuído</option>
              <option>N2 - Suporte e Gestão de Serviços</option>
            </select>
          </div>

          <div class="change-sector-container">
            <span>Aprovação: </span>
            <select v-model="approval" class="form-control">
              <option value="" disabled>Selecione uma opção</option>
              <option value="pendente">Pendente</option>
              <option value="aprovado">Aprovado</option>
              <option value="reprovado">Reprovado</option>
            </select>
          </div>

          <div class="change-sector-container">
            <span>Status: </span>
            <select v-model="status" class="form-control">
              <option value="" disabled>Selecione um status</option>
              <option>Aberto</option>
              <option>Em andamento</option>
              <option>Fechado</option>
            </select>
          </div>

          <b-button variant="dark" @click="toggleNoteModal($event)">
            <i class="fas fa-sticky-note"></i>
            Adicionar anotação
          </b-button>

          <b-button v-if="!Object.keys(getlogchat.feedback).length && getlogchat.type === 'Whatsapp'" variant="success"
            @click="toggleFeedbackModal($event)">
            <i class="fas fa-comment"></i>
            Enviar feedback
          </b-button>

          <b-button variant="primary" @click="downloadPdf()">
            <i class="fas fa-download"></i>
            Baixar PDF
          </b-button>
          <b-button v-if="attachments.length > 0" variant="success" @click="updateAttachments()">
            <i class="fas fa-download"></i>
            Enviar anexos
          </b-button>
        </div>
      </template>

      <VueHtml2pdf class="d-none" :show-layout="false" :float-layout="true" :enable-download="true"
        :preview-modal="true" :filename="filename" :pdf-quality="2" :manual-pagination="true" pdf-format="a4"
        pdf-orientation="portrait" ref="html2Pdf">
        <section slot="pdf-content">
          <div class="modal-log pdf-wrapper">
            <fieldset class="made-up" v-if="this.getlogchat.nome || this.getlogchat.texto">
              <legend>Técnicas</legend>
              <div class="row">
                <div class="col-md-12" v-if="this.getlogchat.nome">
                  <label for="nome"><strong>Nome</strong></label>
                  <input class="form-control" v-model="this.getlogchat.nome" type="text" id="nome" name="nome" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.texto">
                  <label for="texto"><strong>Texto</strong></label>
                  <div v-html="getlogchat.texto" class="variable-height-input"></div>
                </div>
              </div>
            </fieldset>

            <fieldset class="made-up"
              v-if="this.getlogchat.contato || this.getlogchat.protocolo || this.getlogchat.assunto || this.getlogchat.created_at || this.getlogchat.created_by || this.getlogchat.motivo">
              <legend>Dados do Atendimento</legend>
              <div class="row">
                <div class="col-md-12 espcForm" v-if="this.getlogchat.protocolo">
                  <label for="protocolo"><strong>Protocolo</strong></label>
                  <input class="form-control" v-model="this.getlogchat.protocolo" type="text" id="protocolo"
                    name="protocolo" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.date">
                  <label for="date"><strong>Data do Atendimento</strong></label>
                  <input class="form-control" v-model="this.getlogchat.date" type="text" id="date" name="date" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.sla">
                  <label for="sla"><strong>Prazo</strong></label>
                  <input class="form-control" v-model="this.getlogchat.sla" type="text" id="sla" name="sla" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.numberId">
                  <label for="numberId"><strong>Número do ID</strong></label>
                  <input class="form-control" v-model="this.getlogchat.numberId" type="text" id="numberId"
                    name="numberId" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.routeNumber">
                  <label for="routeNumber"><strong>Número da Rota</strong></label>
                  <input class="form-control" v-model="this.getlogchat.routeNumber" type="text" id="routeNumber" name="routeNumber"
                    disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.atmNumber">
                  <label for="atmNumber"><strong>Número do ATM</strong></label>
                  <input class="form-control" v-model="this.getlogchat.atmNumber" type="text" id="atmNumber" name="atmNumber"
                    disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.sector">
                  <label for="sector"><strong>Área Responsável</strong></label>
                  <input class="form-control" v-model="this.getlogchat.sector" type="text" id="sector" name="sector"
                    disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.approval">
                  <label for="approval"><strong>Aprovação</strong></label>
                  <input class="form-control" v-model="this.getlogchat.approval" type="text" id="approval" name="approval"
                    disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.motivo">
                  <label for="motivo"><strong>Motivo de Acionamento</strong></label>
                  <input class="form-control" v-model="this.getlogchat.motivo" type="text" id="motivo" name="motivo"
                    disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.assunto">
                  <label for="assunto"><strong>Assunto</strong></label>
                  <input class="form-control" v-model="this.getlogchat.assunto" type="text" id="assunto" name="assunto"
                    disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.created_at">
                  <label for="created_at"><strong>Data de Criação</strong></label>
                  <input class="form-control" v-model="this.getlogchat.created_at" type="text" id="created_at"
                    name="created_at" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.created_by">
                  <label for="created_by"><strong>Criado por</strong></label>
                  <input class="form-control" v-model="this.getlogchat.created_by" type="text" id="created_by"
                    name="created_by" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.updated_at">
                  <label for="updated_at"><strong>Data de Alteração</strong></label>
                  <input class="form-control" v-model="this.getlogchat.updated_at" type="text" id="updated_at"
                    name="updated_at" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.updated_by">
                  <label for="updated_by"><strong>Alterado por</strong></label>
                  <input class="form-control" v-model="this.getlogchat.updated_by" type="text" id="updated_by"
                    name="updated_by" disabled>
                </div>
              </div>
            </fieldset>

            <fieldset class="made-up"
              v-if="this.getlogchat.NomeCliente || this.getlogchat.cnpj || this.getlogchat.nomePonto || this.getlogchat.codigoPonto || this.getlogchat.endereco || this.getlogchat.cep">
              <legend>Dados da Base</legend>
              <div class="row">
                <div class="col-md-12" v-if="this.getlogchat.NomeCliente">
                  <label for="NomeCliente"><strong>Cliente</strong></label>
                  <input class="form-control" v-model="this.getlogchat.NomeCliente" type="text" id="NomeCliente"
                    name="NomeCliente" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.cnpj">
                  <label for="cnpj"><strong>CNPJ</strong></label>
                  <input class="form-control" v-model="this.getlogchat.cnpj" type="text" id="cnpj" name="cnpj" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.nomePonto">
                  <label for="nomePonto"><strong>Nome do Ponto</strong></label>
                  <input class="form-control" v-model="this.getlogchat.nomePonto" type="text" id="nomePonto"
                    name="nomePonto" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.codigoPonto">
                  <label for="codigoPonto"><strong>Código Único do Ponto</strong></label>
                  <input class="form-control" v-model="this.getlogchat.codigoPonto" type="text" id="codigoPonto"
                    name="codigoPonto" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.Base">
                  <label for="base"><strong>Base</strong></label>
                  <input class="form-control" v-model="this.getlogchat.Base" type="text" id="base" name="base" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.endereco">
                  <label for="endereco"><strong>Endereço</strong></label>
                  <input class="form-control" v-model="this.getlogchat.endereco" type="text" id="endereco"
                    name="endereco" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.cep">
                  <label for="cep"><strong>CEP</strong></label>
                  <input class="form-control" v-model="this.getlogchat.cep" type="text" id="cep" name="cep" disabled>
                </div>
              </div>
            </fieldset>

            <fieldset class="made-up"
              v-if="this.getlogchat && this.getlogchat.feedback && Object.keys(this.getlogchat.feedback).length">
              <legend>Feedback</legend>
              <div class="row">
                <div class="col-md-12" v-if="this.getlogchat.feedback.updated_by">
                  <label for="userName"><strong>Enviado por</strong></label>
                  <input class="form-control" v-model="this.getlogchat.feedback.updated_by" type="text" id="userName"
                    name="userName" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.feedback.updated_at">
                  <label for="nomePonto"><strong>Data de envio</strong></label>
                  <input class="form-control" v-model="this.getlogchat.feedback.updated_at" type="text" id="nomePonto"
                    name="nomePonto" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.feedback.message">
                  <label for="codigoPonto"><strong>Mensagem</strong></label>
                  <div class="form-control html-input" v-html="this.getlogchat.feedback.message" id="codigoPonto"
                    name="codigoPonto" disabled></div>
                </div>
              </div>
            </fieldset>

            <fieldset class="made-up avoid-page-break"
              v-if="this.getlogchat && this.getlogchat.notes && this.getlogchat.notes.length">
              <legend>Anotações</legend>
              <div class="notes-container">
                <div v-for="(note, index) in getlogchat.notes" :key="index" class="note-item">
                  <span>{{ note.created_by }} - {{ moment(note.created_at).format('DD/MM/YYYY \à\\s HH:mm:ss') }}</span>
                  <div class="form-control html-input" v-html="note.note.replace(/\n/g, '<br>')" type="text" disabled>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="made-up avoid-page-break"
              v-if="this.getlogchat && this.getlogchat.attachments && this.getlogchat.attachments.length">
              <legend>Anexos</legend>
              <div class="attachments-container">
                <div class="composer-attachments"
                  v-if="this.getlogchat.attachments && this.getlogchat.attachments?.length > 0">
                  <ul style="grid-template-columns:none; word-wrap: break-word; overflow-wrap: break-word;">
                    <li v-for="(attachment, attachIndex) in this.getlogchat.attachments" :key="attachIndex" style="word-break: break-all; white-space: normal;">
                      <span>
                        <i :class="getFileIcon(attachment.filename)"></i>
                        <span style="word-break: break-all; overflow-wrap: break-word;">{{ attachment.download_url }}</span>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </fieldset>

            <fieldset class="made-up avoid-page-break"
              v-if="this.getlogchat && this.getlogchat.survey && Object.keys(this.getlogchat.survey).length">
              <legend>Pesquisa de Satisfação</legend>
              <div class="row">
                <div class="col-md-12" v-if="this.getlogchat.survey.avaliacao">
                  <label for="userName"><strong>Avaliação</strong></label>
                  <input class="form-control" v-model="this.getlogchat.survey.avaliacao" type="text" id="userName"
                    name="userName" disabled>
                </div>
                <div class="col-md-12 espcForm" v-if="this.getlogchat.survey.reason">
                  <label for="nomePonto"><strong>Razão da insatisfação</strong></label>
                  <input class="form-control" v-model="this.getlogchat.survey.reason" type="text" id="nomePonto"
                    name="nomePonto" disabled>
                </div>
              </div>
            </fieldset>
          </div>
        </section>
      </VueHtml2pdf>
    </b-modal>

    <feedbackModal v-if="feedbackModalShow" :showModal="feedbackModalShow" @closeFeedbackModal="toggleFeedbackModal"
      :requirementInfo="requirementInfo"></feedbackModal>

    <noteModal v-if="noteModalShow" :showModal="noteModalShow" @closeNoteModal="toggleNoteModal"
      :requirementInfo="requirementInfo" :closeAfter="noteCloseAfter"></noteModal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import VueHtml2pdf from 'vue-html2pdf';
import moment from 'moment'

export default {
  components: {
    VueHtml2pdf
  },
  data: () => ({
    moment: moment,
    filename: '',
    feedbackModalShow: false,
    noteModalShow: false,
    requirementInfo: {},
    actAfterNote: null,
    noteCloseAfter: false,
    sector: '',
    status: '',
    approval: '',
    approvalInitialized: false,
    sectorInitialized: false,
    statusInitialized: false,
    closingAfterApprovalChange: false,
    attachments: [],
  }),
  computed: {
    ...mapGetters(['getlogchat'])
  },
  methods: {
    async openModal() {
      this.$bvModal.show('bv-modal-tecnicas');

      this.approval = this.getlogchat.approval;
      this.sector = this.getlogchat.sector;
      this.status = this.getlogchat.status;

      this.$nextTick(() => {
        this.approvalInitialized = true;
        this.sectorInitialized = true;
        this.statusInitialized = true;
      });

      this.filename = `tecnicas_${this.getlogchat.protocolo}_${moment().unix()}`
      if (this.getlogchat.texto) {
        this.getlogchat.texto = this.getlogchat.texto.replaceAll('position: absolute; ', '')
        this.getlogchat.texto = this.getlogchat.texto.replaceAll('width: auto', 'width: 100%; margin-bottom: 5px')
      }
    },
    downloadPdf() {
      this.$refs.html2Pdf.generatePdf();
    },
    changeStatus() {
      const payload = {
        status: this.status,
        old_status: this.getlogchat.status,
        solicitationId: this.getlogchat.id,
        updatedBy: user.getName(),
        type: 'relato'
      }

      if (this.getlogchat.recordType == 'mysql') {
        axios.get(`/solicitacoes/changeStatusMysql/${this.getlogchat.id}`).then(({ data }) => {
          if (data.status == 'success') {
            Swal.fire({
              type: "success",
              title: "Sucesso",
              text: "Status atualizado com sucesso"
            });

            this.$emit('reload')
            this.$bvModal.hide('bv-modal-tecnicas');
          } else {
            Swal.fire({
              type: "error",
              title: "Error",
              text: "Ocorreu um erro ao atualizar o status"
            });
          }
        });
      } else {
        axios.post('/solicitacoes/changeStatusMongo', payload).then(({ data }) => {
          if (data.status == 'success') {
            Swal.fire({
              type: "success",
              title: "Sucesso",
              text: "Status atualizado com sucesso"
            });

            this.getlogchat.status = this.status;
            this.$emit('reload');
            this.$bvModal.hide('bv-modal-tecnicas');
          } else {
            Swal.fire({
              type: "error",
              title: "Error",
              text: "Ocorreu um erro ao atualizar o status"
            });
          }
        });
      }
    },
    toggleFeedbackModal(data) {
      this.requirementInfo = this.getlogchat
      this.feedbackModalShow = !this.feedbackModalShow;
      if (data === 'saving') {
        this.$emit('reload')
        this.$bvModal.hide('bv-modal-tecnicas');
      }
    },
    toggleNoteModal(data) {
      this.requirementInfo = this.getlogchat
      this.noteModalShow = !this.noteModalShow;
      this.noteCloseAfter = false;
      if (data === 'saving') {
        if (this.actAfterNote === 'status') {
          this.changeStatus();
        } else if (this.actAfterNote === 'approval') {
          this.changeApproval();
        }
        
        this.actAfterNote = null;
        this.$emit('reload');
        this.$bvModal.hide('bv-modal-tecnicas');
      }
    },
    changeSector() {
      try {
        axios.get(`/solicitacoes/changeSector/`, {
          params: {
            id: this.getlogchat.id,
            sector: this.sector
          }
        }).then(({ data }) => {
          if (data.status == 'success') {
            Swal.fire({
              type: "success",
              title: "Sucesso",
              text: "Área responsável atualizada com sucesso"
            });

            this.getlogchat.sector = this.sector
            this.$emit('reload')
          }
          else {
            Swal.fire({
              type: "error",
              title: "Error",
              text: "Ocorreu um erro ao atualizar a área responsável"
            });
          }
        });
      } catch (error) {
        Swal.fire({
          type: "error",
          title: "Error",
          text: "Ocorreu um erro ao atualizar a área responsável"
        });
      }
    },
    changeApproval() {
      try {
        axios.get(`/solicitacoes/changeApproval/`, {
          params: {
            id: this.getlogchat.id,
            approval: this.approval
          }
        }).then(({ data }) => {
          if (data.status == 'success') {
            Swal.fire({
              type: "success",
              title: "Sucesso",
              text: "Aprovação atualizada com sucesso"
            });

            this.getlogchat.approval = this.approval
            if(this.approval === 'aprovado' || this.approval === 'reprovado'){
              this.status = 'Fechado'
              this.closingAfterApprovalChange = true
            }
            this.$emit('reload')
          }
          else {
            Swal.fire({
              type: "error",
              title: "Error",
              text: "Ocorreu um erro ao atualizar a aprovação"
            });
          }
        });
      } catch (error) {
        Swal.fire({
          type: "error",
          title: "Error",
          text: "Ocorreu um erro ao atualizar a aprovação"
        });
      }
    },
    getFileIcon(fileName) {
      const extension = fileName.split('.').pop().toLowerCase();
      const iconMap = {
        // Imagens
        'jpg': 'fas fa-file-image',
        'jpeg': 'fas fa-file-image',
        'png': 'fas fa-file-image',
        'gif': 'fas fa-file-image',
        'bmp': 'fas fa-file-image',
        'svg': 'fas fa-file-image',
        // Documentos
        'pdf': 'fas fa-file-pdf',
        'doc': 'fas fa-file-word',
        'docx': 'fas fa-file-word',
        'xls': 'fas fa-file-excel',
        'xlsx': 'fas fa-file-excel',
        'ppt': 'fas fa-file-powerpoint',
        'pptx': 'fas fa-file-powerpoint',
        'txt': 'fas fa-file-alt',
        // Áudio
        'mp3': 'fas fa-file-audio',
        'wav': 'fas fa-file-audio',
        'ogg': 'fas fa-file-audio',
        // Vídeo
        'mp4': 'fas fa-file-video',
        'avi': 'fas fa-file-video',
        'mov': 'fas fa-file-video',
        'mkv': 'fas fa-file-video',
        // Arquivos compactados
        'zip': 'fas fa-file-archive',
        'rar': 'fas fa-file-archive',
        '7z': 'fas fa-file-archive',
        // Código
        'html': 'fas fa-file-code',
        'css': 'fas fa-file-code',
        'js': 'fas fa-file-code',
        'json': 'fas fa-file-code',
        'xml': 'fas fa-file-code',
        'php': 'fas fa-file-code',
        'py': 'fas fa-file-code',
        // Padrão
        default: 'fas fa-file-alt'
      };

      return iconMap[extension] || iconMap.default;
    },
    textSizeLimit(text = "", size = 100) {
      if (typeof text != "string" || typeof size != "number") return text;
      const pontoIndex = text.lastIndexOf('.');

      if (pontoIndex === -1) {
        return text.substring(0, size);
      }

      const extensao = text.substring(pontoIndex);
      const nome = text.substring(0, pontoIndex);

      const tamanhoDisponivel = size - extensao.length;

      if (tamanhoDisponivel <= 0) {
        return extensao.substring(0, size);
      }

      return nome.substring(0, tamanhoDisponivel) + extensao;
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    addAttach() {
      if (this.attachments.length >= 10) {
        Swal.fire({
          title: 'Limite de arquivos excedido',
          text: 'É possível anexar no máximo 10 arquivos.',
          type: 'warning',
          confirmButtonText: 'OK'
        });
        return;
      }

      const input = document.createElement('input');
      input.type = 'file';
      input.multiple = true;
      input.onchange = (e) => {
        const files = Array.from(e.target.files);
        const remainingSlots = 10 - this.attachments.length;

        if (files.length > remainingSlots) {
          Swal.fire({
            title: 'Limite de arquivos excedido',
            text: `É possível anexar no máximo 10 arquivos.`,
            type: 'warning',
            confirmButtonText: 'OK'
          });
          this.attachments = [...this.attachments, ...files.slice(0, remainingSlots)];
        } else {
          this.attachments = [...this.attachments, ...files];
        }
      };
      input.click();
    },
    removeAttach(index) {
      this.attachments.splice(index, 1);
    },
    updateAttachments() {
      const formData = new FormData();
      this.attachments.forEach((file) => {
        formData.append('attachments[]', file);
      });

      axios.post(`solicitacoes/updateAttachmentsRequest/${this.getlogchat.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(() => {
        Swal.fire({
          type: 'success',
          text: 'Anexos enviados com sucesso!',
          timer: 2000,
          toast: true,
          showConfirmButton: false,
          position: 'top-end'
        });
        this.attachments = [];
        this.$emit('reload', {item: this.getlogchat, reloadDetails: true})
      })
    }
  },
  watch: {
    sector(newVal) {
      if (!this.sectorInitialized) return;

      if (newVal !== this.getlogchat.sector) {
        const name = newVal !== '' ? newVal : 'Não atribuído'
        Swal.fire({
          title: 'Alteração de Área Responsável',
          text: `Deseja alterar a área responsável para "${name}"?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não'
        }).then((result) => {
          if (result.value) {
            this.changeSector();
          } else {
            this.sector = this.getlogchat.sector;
          }
        });
      }
    },
    approval(newVal) {
      if (!this.approvalInitialized) return;
      if (newVal !== this.getlogchat.approval) {
        const name = newVal !== '' ? newVal : 'Não atribuído';
        let textInformation = `<p>Deseja alterar a aprovação para "${name}"?</p>`;
        const notPendente = newVal?.toLowerCase() != "pendente";
        if (notPendente) {
          textInformation = textInformation + `<p>Para aprovar ou reprovar uma solicitação, é necessário adicionar um comentário para fechamento!</p>`
        }
        Swal.fire({
          title: 'Alteração de Aprovação',
          html: textInformation,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não'
        }).then((result) => {
          if (result?.value) {
            if (notPendente) {
              this.actAfterNote = "approval";
              this.requirementInfo = this.getlogchat;
              this.noteCloseAfter = true;
              this.noteModalShow = true;
            } else {
              this.changeApproval();
            }
          } else {
            this.approval = this.getlogchat.approval;
          }
        });
      }
    },
    status(newVal) {
      if (!this.statusInitialized) return;

      if(this.closingAfterApprovalChange){
        this.changeStatus();
        this.closingAfterApprovalChange = false;
      } else {
        if (newVal !== this.getlogchat.status) {
          Swal.fire({
            title: 'Alteração de Status',
            html: `<p>Deseja alterar o status para "${newVal}"?</p>
            <p><strong>Obs: </strong>Para fechar ou reabrir a solicitação, é necessário adicionar um comentário!</p>`,
            type: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
          }).then((result) => {
            if (result?.value) {
              if(this.getlogchat.status.toLowerCase() == 'aberto' && newVal.toLowerCase().includes('andamento')){
                this.changeStatus();
              } else {
                this.actAfterNote = "status";
                this.requirementInfo = this.getlogchat;
                this.noteCloseAfter = true;           
                this.noteModalShow = true;
                return; 
              }
              this.actAfterNote = null;
              this.noteCloseAfter = false;
            } else {
              this.status = this.getlogchat.status;
            }
          });
        }
      }

    }
  }
}
</script>

<style scoped lang="scss">
.modal-log {
  overflow-y: auto;
  overflow-x: hidden;
}

.modal-log .espcForm {
  margin: 5px 0px 0px 0px;
}

.modal-log label,
input,
textarea {
  font-size: 12px;
}

.made-up {
  font-family: arial;
  margin: 10px;
  border-radius: 10px;
  background: #fff;
  border: solid 1px #9797A6;
  border-radius: 2px;
  padding: 10px;
}

.made-up fieldset {
  margin: 5px 30px;
}

fieldset {
  page-break-inside: avoid;
  break-inside: avoid;
}

.pdf-wrapper {
  page-break-before: auto;
  page-break-after: auto;
}

.made-up legend {
  background: #1C869A;
  color: #FEFEFE;
  margin: 0px;
  padding: 5px 20px;
  width: auto;
  font-size: 14px;
  border-radius: 2px;
}

.avoid-page-break {
  page-break-inside: avoid;
}

textarea {
  display: inline-block;
  width: 100%;
  padding: 0px 10px;
  overflow-y: auto;
  overflow-x: hidden;
}

.textoPDF {
  display: inline-block;
  width: 100%;
  padding: 0px 10px;
  overflow-y: auto;
  overflow-x: hidden;
}

.buttons-container {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 30px;

  button {
    font-size: small;
    padding: 5px;
    border-radius: 5px !important;
    white-space: nowrap;
  }

  .change-sector-container {
    display: flex;
    align-items: center;
    gap: 5px;

    span {
      font-weight: bold;
      white-space: nowrap;
    }

    select {
      font-size: small;
      cursor: pointer;
      border-radius: 10px !important;
    }
  }
}

.fixed-height-input {
  height: 200px;
  max-height: 200px;
  overflow: auto;
  border: 1px solid lightgray;
  background-color: #e9ecef;
  white-space: pre-line;
}

.variable-height-input {
  height: auto;
  background-color: #e9ecef;
  border: 1px solid lightgray;
  font-size: smaller;
}

.html-input {
  height: auto;
  background-color: #e9ecef;
  font-size: smaller;
  white-space: pre-line;
  word-wrap: break-word;
  padding: 5px;
}

.notes-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.note-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
  border: 1px solid lightgray;
  padding: 10px;
  border-radius: 5px;

  span {
    background-color: #1c869a;
    color: white;
    font-weight: bold;
    padding-left: 5px;
  }
}

.composer-attachments {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.composer-attachments>h5 {
  font-size: 13px;
  margin: 0 0 10px 0;
}

.composer-attachments>ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.composer-attachments>ul>li {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #f1f1f1;
  padding: 4px 8px;
  border-radius: 3px;
  font-size: 12px;
  border: 1px solid #9797A6
}

.composer-attachments>ul>li>span {
  display: flex;
  align-items: center;
  gap: 5px;
}

.checkbox-group {
  display: flex;
  gap: 5px;
  width: 150px;
  margin: 10px 0px;
  padding: 2px 10px;
  height: fit-content;
  align-self: end;
  cursor: pointer;
  border: 1px solid #ededed;
  border-radius: 10px;
  box-shadow: 1px 1px 2px 0px lightgray;
  transition: ease-in-out 0.2s;

  span {
    white-space: nowrap;
    align-content: center;
    font-weight: bold;
  }

  &:hover {
    background-color: #ededed;
  }
}

.remove-attachment-btn {
  background: none;
  border: none;
  color: #dc3545;
  font-weight: bold;
  cursor: pointer;
  font-size: 14px;
  padding: 0 5px;
}
</style>